import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { BehaviorSubject, of } from 'rxjs';
import { filter, pairwise, scan, switchMap } from 'rxjs/operators';
import { fecha } from 'src/environments/fecha';
import { ultimaActualizacion } from 'src/environments/version';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private dialog: HTMLIonLoadingElement;
  private loading = false;
  private toggleLoading$ = new BehaviorSubject<number>(0);

  constructor(private loadingController: LoadingController) {
    this.toggleLoading$
      .pipe(
        scan((acc, curr) => Math.max(0, acc + curr), 0),
        pairwise(),
        switchMap(([prev, curr]) => {
          if (prev === 1 && curr === 0) {
            this.loading = true;
            this.dialog?.dismiss().finally(()=>this.dialog = null);
          }else if (((prev< curr && curr>0) || (prev>curr) )&& !this.dialog) {
            return this.loadingController.create({
              message: `
                <ion-spinner name="dots" class="spinner-dots"></ion-spinner>
                 <div>APP VENDEDORES</div>
                <div><small>Última actualización:</small><br> ${ultimaActualizacion}</div>
              `,
              cssClass: 'custom-loading-vertical',
              spinner: null,
              backdropDismiss: false,
            });
          };
          return of(null);
        }),
        filter((d: HTMLIonLoadingElement| null) => !!d)
      )
      .subscribe((d: HTMLIonLoadingElement) => {
        d.present().then(() => {
          try {
            (d as any).style.zIndex = '30000';
            document.body.appendChild(d);
          } catch {
            // noop
          }
        });
        this.dialog = d;
      });
  }

  showLoading() {
    this.toggleLoading$.next(1);
  }

  hideLoading() {
    this.toggleLoading$.next(-1);
  }
}
